import React from 'react';
import { Box, Grid, Typography, Button } from '@mui/material';
import { Link } from 'react-router-dom';
import AffiliateAboutBanner from '../../assets/images/people_banner.jpg';
import RoutePaths from '../../configs/Routes';

const LookingForNewFaces = () => (
  <Box
    sx={{
      position: 'relative',
      backgroundImage: `url(${AffiliateAboutBanner})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      py: { xs: 6, md: 12 },
      px: { xs: 2, md: 4 },
      textAlign: 'center',
      color: '#fff',
    }}
  >
    {/* Dark overlay */}
    <Box
      sx={{
        position: 'absolute',
        inset: 0,
        bgcolor: 'rgba(0,0,0,0.8)',
        zIndex: 1,
      }}
    />

    {/* Content */}
    <Box sx={{ position: 'relative', zIndex: 2 }}>
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        sx={{ maxWidth: 1000, margin: '0 auto' }}
      >
        <Grid item xs={12}>
          <Typography
            component="h3"
            variant="h3"
            fontFamily='"Archivo Black", sans-serif'
            fontWeight={900}
            gutterBottom
          >
            We&apos;re Looking for New Faces!
          </Typography>

          <Typography
            variant="subtitle1"
            fontWeight={400}
            sx={{ mt: 1, mb: 3, lineHeight: 1.4, maxWidth: '90%', mx: 'auto' }}
          >
            Looking for a way to earn extra cash? Consider becoming an affiliate for
            CanAm Excursions! As an affiliate, you’ll be able to promote our
            exciting travel packages to your followers and earn up to 10%
            for every successful referral.
          </Typography>

          <Button
            variant="contained"
            size="large"
            LinkComponent={Link}
            to={RoutePaths.SIGN_UP}
            sx={{
              bgcolor: '#FF6B00',
              color: '#fff',
              px: 4,
              py: 1.5,
              fontSize: '1rem',
              borderRadius: 10,
              textTransform: 'uppercase',
              fontWeight: 500,
              '&:hover': { bgcolor: '#ff8c00' },
            }}
          >
            Earn Extra Cash
          </Button>
        </Grid>
      </Grid>
    </Box>
  </Box>
);

export default LookingForNewFaces;
